var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PasswordResetPopup',{attrs:{"show":_vm.showPasswordReset,"token":_vm.resetPasswordToken}}),_c('Header'),_c('CardsListAll',{attrs:{"title":'Все методы'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }